import { AnimatePresence, motion } from 'framer-motion';
import { type FC, type ReactNode } from 'react';

export const ContentItemBoxExpandableContainer: FC<{ expandedContent?: ReactNode; open: boolean }> = ({
    expandedContent,
    open,
}) =>
    expandedContent ? (
        <AnimatePresence initial={false}>
            {open && (
                <motion.div
                    initial={{ opacity: 0, y: -10, height: 0 }}
                    animate={{ opacity: 1, y: 0, height: 'auto' }}
                    exit={{ opacity: 0, y: -10, height: 0 }}
                    transition={{ duration: 0.2, ease: 'easeInOut' }}
                    className="cursor-default overflow-hidden border-t-1 border-solid border-t-slate-grey-200 group-hover:border-t-slate-grey-300"
                >
                    {expandedContent}
                </motion.div>
            )}
        </AnimatePresence>
    ) : null;
